import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import Select from 'react-select';
import { Helmet } from 'react-helmet-async';
import './SignUp.css';
import axios from 'axios';

function Locations() {
    const navigate = useNavigate();
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [options, setOptions] = useState([]);

    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

    const fetchLocations = async () => {
        try {
          const response = await axios.get(`${API_ENDPOINT}/api/locations/`);
          const locationOptions = response.data.map(location => ({
            value: location.location_id,
            label: location.location_name
          }));
          setOptions(locationOptions); 
          
        } catch (error) {
          console.error('Error fetching location:', error);
        }
    };
    
    const handleSignUp = async (event) => {
        event.preventDefault();

        if (selectedLocations.length === 0) {
            alert('All fields are required.');
            return;
        }
    
        const subscribedLocations = selectedLocations.map(location => location.value);
        localStorage.setItem('locations', JSON.stringify(subscribedLocations));

        navigate('/calendar');
    };

    useEffect(() => {
        fetchLocations();
    }, []);

    return (
        <div>
            <div className="signup-page">
                <Helmet>
                    <title>Enroll in Autobook</title>
                    <meta name="description" content="Enroll in our Autobook service to automatically secure your Global Entry interview appointment at your preferred locations." />
                    <link rel="canonical" href="https://www.easyglobalentry.com/autobook" />
                </Helmet>
                <Container className="signup-container2">
                    <h1 className="center-text" style={{ fontSize: '2rem' }}>Select Enrollment Locations</h1>
                   <p className="center-text">
                        Select up to three Global Entry enrollment centers. 
                        Our system will automatically search for and book an appointment at these locations based on your availability.
                    </p>
                    <Form onSubmit={handleSignUp}>
                        <Form.Group className="mb-3" controlId="formLocations">
                            <Form.Label className="bold-label">Locations</Form.Label>                
                            <Select 
                                options={options} 
                                isMulti 
                                isSearchable 
                                onChange={(selectedOptions) => {
                                    if (selectedOptions.length > 3) {
                                        alert('You can only select up to 3 locations.');
                                    } else {
                                        setSelectedLocations(selectedOptions);
                                    }
                                }}
                                value={selectedLocations}
                            />
                        </Form.Group>

                        <div className="disclaimer">
                        Note: We will search for availability at any of the selected locations. 
                        </div>

                        <div className="center-text">
                            <Button variant="primary" type="submit" className="btn-block custom-button">
                                Confirm Locations
                            </Button>
                        </div>
                    </Form>
                </Container>
            </div>
        </div>
    );
}

export default Locations;